export default function Testimonial() {
  return (
    <section className="w-full py-16 md:py-24 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="relative bg-foreground-950 rounded-3xl overflow-hidden">
          <div className="absolute top-0 left-0 w-full h-full opacity-5">
            <div className="absolute -top-20 -left-20 w-80 h-80 rounded-full border-[60px] border-accent-500"></div>
            <div className="absolute -bottom-20 -right-20 w-96 h-96 rounded-full border-[70px] border-primary-500"></div>
          </div>

          <div className="flex flex-col lg:flex-row">
            <div className="lg:w-[40%] relative">
              <div className="relative -ml-6 lg:-ml-12 my-8 lg:my-12">
                <img
                  src="https://readdy.ai/api/search-image?query=Confident%20young%20entrepreneur%20sitting%20at%20modern%20minimalist%20workspace%20with%20laptop%20showing%20spreadsheet%20dashboard%20warm%20ambient%20lighting%20professional%20yet%20relaxed%20atmosphere%20cream%20walls%20editorial%20portrait%20photography%20authentic%20expression&width=600&height=800&seq=testimonial-user-v2&orientation=portrait"
                  alt="OOPBuy Spreadsheet user success story"
                  title="OOPBuy Spreadsheet - User Success Story"
                  className="rounded-2xl w-full object-cover aspect-[3/4]"
                  loading="lazy"
                />
              </div>
            </div>

            <div className="lg:w-[60%] flex items-center p-8 md:p-12 lg:p-16">
              <div className="flex flex-col gap-6">
                <span className="text-accent-300 font-heading text-8xl md:text-9xl leading-none select-none">
                  &ldquo;
                </span>
                <blockquote className="text-white text-lg md:text-xl lg:text-2xl leading-relaxed font-light">
                  Switching to the OOPBuy spreadsheet system completely transformed how I manage my e-commerce inventory. I used to spend hours manually tracking products across suppliers. Now everything is automated — my profit margins are clearer, my supplier data is organized, and I can focus on actually growing my business instead of drowning in spreadsheets.
                </blockquote>
                <div className="flex flex-col gap-1">
                  <span className="text-white font-semibold text-base">Alex R.</span>
                  <span className="text-white/60 text-sm">E-commerce Reseller, 3 Years on Platform</span>
                </div>
                <a
                  href="https://kaspreadsheet.com/"
                  target="_blank"
                  rel="noopener nofollow"
                  className="inline-flex items-center gap-2 bg-accent-500 text-white px-7 py-3 rounded-full text-sm font-semibold hover:bg-accent-600 transition-colors duration-200 cursor-pointer whitespace-nowrap w-fit"
                >
                  Read Full Review
                  <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}